/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.question.QuestionWeight
*/
export var QuestionWeight;
(function (QuestionWeight) {
    QuestionWeight["BLOCKER"] = "BLOCKER";
    QuestionWeight["IMPORTANT"] = "IMPORTANT";
    QuestionWeight["MINOR"] = "MINOR";
})(QuestionWeight || (QuestionWeight = {}));
//# sourceMappingURL=QuestionWeight.js.map